import { HttpClient } from "@angular/common/http";
import { inject, Injectable } from "@angular/core";
import { firstValueFrom } from "rxjs";

import { URLS } from "../../constants/constants";
import { AuthService } from "../../../common/services/auth.service";
import { GetLineItemsResponseDto } from "../dtos/get-line-items.response.dto";



@Injectable()
export class LineItemsService {
private http = inject(HttpClient);
private authService = inject(AuthService)
    
    getLineItems({skip,limit,sortField,sortOrder,searchQuery}:{skip:number,limit:number,sortField:string,sortOrder:string,searchQuery?:string}) : Promise<GetLineItemsResponseDto>{
        let url = `${URLS.LINE_ITEMS_API}?skip=${skip}&limit=${limit}&sortField=${sortField}&sortOrder=${sortOrder}`;
        if (searchQuery) {
            url += `&searchQuery=${encodeURIComponent(searchQuery)}`;
        }
        return firstValueFrom(this.http.get<GetLineItemsResponseDto>(url, {
            headers: this.authService.getAuthHeaders()
        })); 
    }
   
   
}